// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cb2e92ac","987":"77bc9c0d"}[chunkId] + ".chunk.js";
};